// Icerik ekranlarinin ORTAK sabitleri ve kucuk yardimcilari.
//
// NEDEN ayri bir dosya: ayni durum haritasi, ayni platform simgesi ve ayni
// tarih bicimleyici yedi ekranda tekrar edince biri degistiginde digerleri
// sessizce geride kaliyor - kullanici ayni gonderiyi iki ekranda iki farkli
// renkte gormeye basliyor. Tek kaynak tutmak bunu imkansiz kiliyor.
//
// Burada BILEREK istek atan bir sey yok: her ekran kendi verisini kendi
// cekiyor. Bu dosya yalnizca "ayni sey ayni gorunsun" isini yapar.

// --- Gonderi durumlari -------------------------------------------------------

// Sunucudaki OmnupGonderi::DURUMLAR ile AYNI sira ve AYNI yazim.
export const DURUMLAR = [
  'taslak',
  'onay_bekliyor',
  'planlandi',
  'yayinlaniyor',
  'yayinlandi',
  'kismi',
  'hata',
];

// Liste suzgecinin secenekleri. Deger dogrudan `?durum=` olarak gidiyor;
// sunucu virgulle ayrilmis coklu durumu kabul ediyor.
//
// NEDEN 'yayinlaniyor' YOK: saniyeler suren bir ara durum. Suzgec olarak
// sunmak, secildiginde cogunlukla bos liste gostermek demek.
// NEDEN 'hata' ile 'kismi' TEK secenek: ikisi de kullanicinin bakmasi gereken
// ayni isin iki tonu ("bir sey yayinlanmadi"). Ayri secenek yapmak, sorunlu
// gonderilerin yarisini gizleyen bir suzgec uretirdi - Genel Bakis'taki hata
// karti da ikisini birlikte sayiyor.
export const SUZGEC_SECENEKLERI = [
  { deger: 'taslak', anahtar: 'ICERIK.DURUM_TASLAK' },
  { deger: 'onay_bekliyor', anahtar: 'ICERIK.DURUM_ONAY_BEKLIYOR' },
  { deger: 'planlandi', anahtar: 'ICERIK.DURUM_PLANLANDI' },
  { deger: 'yayinlandi', anahtar: 'ICERIK.DURUM_YAYINLANDI' },
  { deger: 'hata,kismi', anahtar: 'ICERIK.DURUM_SORUNLU' },
];

// Anahtarlar ACIK yazilir: `ICERIK.DURUM_${durum}` gibi uretilen anahtarlar
// aramada bulunamiyor ve eksik ceviri fark edilmeden kaliyor.
export const DURUM_ANAHTARLARI = {
  taslak: 'ICERIK.DURUM_TASLAK',
  onay_bekliyor: 'ICERIK.DURUM_ONAY_BEKLIYOR',
  planlandi: 'ICERIK.DURUM_PLANLANDI',
  yayinlaniyor: 'ICERIK.DURUM_YAYINLANIYOR',
  yayinlandi: 'ICERIK.DURUM_YAYINLANDI',
  kismi: 'ICERIK.DURUM_KISMI',
  hata: 'ICERIK.DURUM_HATA',
};

// 'kismi' AMBER: hata degil ama kullanicinin bakmasi gereken bir sonuc.
// Kirmiziya boyamak "hicbir sey yayinlanmadi" izlenimi verirdi; griye
// boyamak sorunu gizlerdi.
export const DURUM_RENKLERI = {
  taslak: 'text-n-slate-11 bg-n-alpha-1',
  onay_bekliyor: 'text-n-amber-11 bg-n-alpha-1',
  planlandi: 'text-n-blue-11 bg-n-alpha-1',
  yayinlaniyor: 'text-n-blue-11 bg-n-alpha-1',
  yayinlandi: 'text-n-teal-11 bg-n-alpha-1',
  kismi: 'text-n-amber-11 bg-n-alpha-1',
  hata: 'text-n-ruby-11 bg-n-alpha-1',
};

// Sunucunun izin verdigi duzenleme durumlari (OmnupGonderi ve denetleyicideki
// KILITLI_DURUMLAR ile ayni karar). Yayinlanmis gonderinin metnini burada
// degistirmek Meta'daki gonderiyi degistirmez, yalnizca ekranla gercegi
// ayristirir.
export const DUZENLENEBILIR_DURUMLAR = [
  'taslak',
  'onay_bekliyor',
  'planlandi',
  'hata',
];

export const duzenlenebilir = gonderi =>
  DUZENLENEBILIR_DURUMLAR.includes(gonderi?.durum);

// Silinebilir mi? Yalnizca "su an is kuyrugunda" olan gonderi silinemez;
// altindan cekmek yarim yayinlanmis bir gonderi birakir.
export const silinebilir = gonderi => gonderi?.durum !== 'yayinlaniyor';

// --- Hedef (hesap basina sonuc) durumlari ------------------------------------

export const HEDEF_DURUM_ANAHTARLARI = {
  bekliyor: 'ICERIK.HEDEF_BEKLIYOR',
  yayinlandi: 'ICERIK.HEDEF_YAYINLANDI',
  hata: 'ICERIK.HEDEF_HATA',
};

export const HEDEF_DURUM_RENKLERI = {
  bekliyor: 'text-n-slate-11',
  yayinlandi: 'text-n-teal-11',
  hata: 'text-n-ruby-11',
};

// --- Platformlar -------------------------------------------------------------
//
// Sunucudaki OmnupIcerikController::PLATFORMLAR haritasinin arayuz karsiligi.
// Burada OLMAYAN platform icin hicbir sey cizilmez: tiklandiginda hicbir sey
// yapmayan bir kutucuk, olmayan ozelligi varmis gibi gostermektir. Yeni bir
// platform sunucuda acildiginda buraya tek satir eklemek yetiyor.
export const PLATFORM_ANAHTARLARI = {
  instagram: 'ICERIK.PLATFORM_INSTAGRAM',
  facebook: 'ICERIK.PLATFORM_FACEBOOK',
};

export const PLATFORM_SIMGELERI = {
  instagram: 'i-ri-instagram-line',
  facebook: 'i-ri-facebook-circle-fill',
};

// Tanimadigimiz platform icin notr bir simge: hedef satirini hic cizmemek,
// gonderinin nereye gittigini gizlemek olurdu.
export const platformSimgesi = platform =>
  PLATFORM_SIMGELERI[platform] || 'i-lucide-share-2';

// --- Tarih / saat ------------------------------------------------------------

// Chatwoot dil kodlari yer yer alt cizgili geliyor (pt_BR gibi); Intl bunu
// gecersiz sayip hata firlatir, tireye cevirmek gerekiyor.
export const bicimDiliCoz = dil => String(dil || 'tr').replace('_', '-');

const bicimle = (deger, dil, ayarlar) => {
  if (!deger) return '';
  const tarih = new Date(deger);
  if (Number.isNaN(tarih.getTime())) return String(deger);
  try {
    return tarih.toLocaleString(bicimDiliCoz(dil), ayarlar);
  } catch (e) {
    // Gecersiz bir dil kodu tum ekrani patlatmasin; Turkce'ye dusuyoruz.
    return tarih.toLocaleString('tr-TR', ayarlar);
  }
};

export const zamanMetni = (deger, dil) =>
  bicimle(deger, dil, { dateStyle: 'medium', timeStyle: 'short' });

export const tarihMetni = (deger, dil) =>
  bicimle(deger, dil, { dateStyle: 'medium' });

// Gun anahtari ('YYYY-MM-DD') YEREL tarihten uretilir. toISOString()
// kullanirsak saat dilimi yuzunden kayit bir onceki/sonraki gune dusebiliyor.
const iki = sayi => String(sayi).padStart(2, '0');

export const gunAnahtari = tarih =>
  `${tarih.getFullYear()}-${iki(tarih.getMonth() + 1)}-${iki(tarih.getDate())}`;

// datetime-local alani "2026-09-20T14:30" bekler ve YEREL saat okur.
export const yerelAlanMetni = tarih =>
  `${gunAnahtari(tarih)}T${iki(tarih.getHours())}:${iki(tarih.getMinutes())}`;

// --- Metin -------------------------------------------------------------------

// Sunucu hata govdesini iki farkli sekilde yolluyor olabilir; ikisini de
// deniyoruz. Hicbiri yoksa cagiranin verdigi metni donuyoruz - "undefined"
// yazan bir uyari kullaniciya hicbir sey anlatmaz.
export const hataMetniniCoz = (e, yedek) =>
  e?.response?.data?.error || e?.message || yedek;

// Listede gonderinin ilk satirlari gorunur. squish: metindeki satir sonlari
// listeyi yirtmasin.
export const ozetle = (metin, sinir = 160) => {
  const temiz = String(metin || '')
    .replace(/\s+/g, ' ')
    .trim();
  if (!temiz) return '';
  return temiz.length > sinir ? `${temiz.slice(0, sinir)}...` : temiz;
};

// Kimlikler turler arasinda cakisabilir; anahtari turle birlestirmezsek Vue
// iki ayri kaydi ayni sanip birini cizmiyor.
export const hedefAnahtari = hedef => `hedef-${hedef.id}`;
